module.exports = require('./helpers/bundle-url').getBundleURL('dXr8Y') + "logo.c51670a8.svg";